
// Get the customer data based on IP and set cookie
function checkIPdata(){
	$.getJSON("https://ipgeolocation.abstractapi.com/v1/?api_key=ffdbd0e697ab4f10bb46e261745b58f8", function(data, status) {
		if (status == "success"){
			console.log(data);			
			if(data.country_code == "US" && data.region_iso_code == "CA"){
				createCookie("customerFromCalifornia", true, 30)
			}
			else{
				createCookie("customerFromCalifornia", false, 30)
			}
		}
	}).fail(function(error){
		console.log(error);
	});
}

function createCookie(name, value, days) {
    var expires;

    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function readCookie(name) {
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name, "", -1);
}

// Initially check for cookie set or not
$(document).ready(function(){
	var customerCookieData = readCookie("customerFromCalifornia");
    if(!customerCookieData){
      checkIPdata();
    }
});



/* // Test with static IP for cusotmer from Clifornia
$.getJSON("https://ipgeolocation.abstractapi.com/v1/?api_key=ffdbd0e697ab4f10bb46e261745b58f8&ip_address=149.142.201.252", function(data, status) {
  console.log(status);
  console.log(data);
  //data;
  
}); */

